import { render, staticRenderFns } from "./ms-write-record.vue?vue&type=template&id=4dda0d78&scoped=true"
import script from "./ms-write-record.vue?vue&type=script&lang=js"
export * from "./ms-write-record.vue?vue&type=script&lang=js"
import style0 from "./ms-write-record.vue?vue&type=style&index=0&id=4dda0d78&prod&lang=scss&scoped=true"
import style1 from "./ms-write-record.vue?vue&type=style&index=1&id=4dda0d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda0d78",
  null
  
)

export default component.exports